import React from 'react'

interface Props {
    _open: boolean
    handleClick: () => void
}
export const HamburguerMenu = ({ _open, handleClick }: Props) => {
    return (
        <div onClick={handleClick}
            className={`icon nav-icon-5 ${_open ? 'open' : ''}`}
        >
            <span></span>
            <span></span>
            <span></span>
        </div>
    )
}
